/** @jsx jsx */

/** @jsxFrag Fragment */
import { css, jsx } from '@emotion/react';

import { languageCodeToName } from 'js/lib/language';

import { Tag } from '@coursera/cds-core';
import { TranslationIcon } from '@coursera/cds-icons';

import { useGetCourseLanguages } from 'bundles/common/queries/useGetCourseLanguages';
import { useGetUserLanguageTranslationType } from 'bundles/course-notifications-v2/components/translatedContent/TranslationNotificationHooks';
import ErrorBoundaryWithLogging from 'bundles/page/components/ErrorBoundaryWithLogging';

import _t from 'i18n!nls/course-notifications-v2';

type Props = {
  courseId: string;
};

const TranslatedContentTagInternal = ({ courseId }: Props) => {
  const { originalLanguage } = useGetCourseLanguages(courseId);
  const translationType = useGetUserLanguageTranslationType(courseId);
  if (!translationType) return null;

  const originalLanguageName = languageCodeToName(originalLanguage);

  let content;
  if (translationType === 'MACHINE') {
    content = _t('Translated automatically from #{originalLanguageName}', { originalLanguageName });
  } else {
    content = _t('Translated from #{originalLanguageName}', { originalLanguageName });
  }

  return (
    <Tag
      css={css`
        margin-left: var(--cds-spacing-100);
      `}
      variant="status"
      priority="secondary"
      icon={<TranslationIcon color="support" size="small" />}
    >
      {content}
    </Tag>
  );
};

const TranslatedContentTag = (props: Props) => {
  return (
    <ErrorBoundaryWithLogging>
      <TranslatedContentTagInternal {...props} />
    </ErrorBoundaryWithLogging>
  );
};

export { TranslatedContentTagInternal };
export default TranslatedContentTag;
